import {createAction} from 'redux-act';

export const setEnvironment = createAction<string>();
export const setCompliance = createAction<boolean>();
export const setBrowserId = createAction<string>();
export const hideLoader = createAction();
